import "./Products.css";
import React, {useContext} from "react";
import {useNavigate} from "react-router-dom";
import {
    AsistenciaViajeroIcon,
    AutomotorIcon,
    BiciIcon,
    CandadoIcon,
    HogarIcon,
    MonopatinIcon,
    MotovehiculoIcon,
    NotebookIcon,
    TabletIcon,
} from '../../../assets/products';
import ClienteDirectoContext from "../../../context/ClienteDirectoContext";

const products = [
    {
        id: 'asistencia_viajero',
        name: 'Asistencia al Viajero',
        path: '/asistenciaviajero',
        icon: AsistenciaViajeroIcon
    },
    {
        id: 'vehiculo',
        name: 'Automotor',
        path: '/automotor',
        icon: AutomotorIcon
    },
    {
        id: 'hogar',
        name: 'Hogar',
        path: '/hogar',
        icon: HogarIcon
    },
    {
        id: 'motovehiculo',
        name: 'Motovehículo',
        path: '/motovehículo',
        icon: MotovehiculoIcon
    },
    {
        id: 'notebook',
        name: 'Notebook',
        path: '/notebook',
        icon: NotebookIcon,
        parent: 'microseguros'
    },
    {
        id: 'tablet',
        name: 'Tablet',
        path: '/tablet',
        icon: TabletIcon,
        parent: 'microseguros'
    },
    {
        id: 'monopatin',
        name: 'Monopatín',
        path: '/monopatin',
        icon: MonopatinIcon,
        parent: 'microseguros'
    },
    {
        id: 'bici',
        name: 'Bicicleta',
        path: '/bicicleta',
        icon: BiciIcon,
        parent: 'microseguros'
    },
    {
        id: 'candado',
        name: 'Robos Varios',
        path: '/robosvarios',
        icon: CandadoIcon,
        parent: 'microseguros'
    },
];

const Producer = () => {

    const {activeProducts} = useContext(ClienteDirectoContext);

    let navigate = useNavigate();
    const finalProducts = products.filter((product) => {
        const isActive = activeProducts[product.id]?.active;
        const isChildOfActive = product.parent && activeProducts[product.parent]?.active;
        return isActive || isChildOfActive;
    });


    return (
        <section className='products'>
            <h1>Productos para <b>cotizar</b></h1>
            <nav
                className={
                    finalProducts.length < 3
                        ? 'few-products'
                        : 'many-products'
                }
            >
                {finalProducts.map((product) => {
                    const Icon = product.icon;
                    return (
                        <button
                            key={product.id}
                            onClick={() => {
                                navigate("cotizar" + product.path);
                                window.scrollTo({top: 0, behavior: "smooth"});
                            }}
                        >
                            <div className='iconContainer'>
                                <Icon className='icon'/>
                            </div>
                            <p>{product.name}</p>
                        </button>
                    );
                })}
            </nav>
        </section>
    )
};

export default Producer;